export const DEVICE_ID_COOKIE_NAME = 'deviceId';
